import Menu from './Compartido/Menu.jsx';
import PaginaNoEncontrada from '../../Components/PaginaNoEncontrada.jsx';
import Footer from './Compartido/Footer.jsx';
import Scripts from './Compartido/Scripts.jsx';

const NoEncontrada = (props) => {
    return (
        <main>
            <Menu
                lang={props.lang}
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
                ruta={props.ruta}
                config={props.websgrupo}
                pagina="5_Aviso-Legal"
                destinos={props.destinos}
                tiposcasas={props.tiposcasas}
            />
            <PaginaNoEncontrada
                urlinicio={props.urlinicio}
                websgrupo={props.websgrupo}
            />
            <Footer
                lang={props.lang}
                datos={props.websgrupo}
            />
            <Scripts />
        </main>
    )
}
export default NoEncontrada;

